export const API_BASE_ROUTES = {
  AUTH: '/api/v1/auth',
  CANDIDATES: '/api/v1/candidates',
  CHAT: '/api/v1/chat',
  JOBS: '/api/v1/jobs',
  NOTIFICATIONS: '/api/v1/notifications',
  INGESTION: '/api/v1/ingestion',
  SCHEDULE: '/api/v1/schedule',
  REPORTS: '/api/v1/reports',
} as const;

export const API_ENDPOINTS = {
  AUTH: {
    REGISTER: `${API_BASE_ROUTES.AUTH}/auth/register`,
    LOGIN: `${API_BASE_ROUTES.AUTH}/auth/login`,
    LOGOUT: `${API_BASE_ROUTES.AUTH}/auth/logout`,
    REFRESH: `${API_BASE_ROUTES.AUTH}/auth/refresh`,
    VALIDATE: `${API_BASE_ROUTES.AUTH}/auth/validate`,
    CHANGE_PASSWORD: `${API_BASE_ROUTES.AUTH}/auth/password/change`,
    FIRST_LOGIN_PASSWORD: `${API_BASE_ROUTES.AUTH}/auth/password/first-login`,
    FORGOT_PASSWORD: `${API_BASE_ROUTES.AUTH}/auth/password/forgot`,
    RESET_PASSWORD_BY_KEY: `${API_BASE_ROUTES.AUTH}/auth/password/reset-by-key`,
    UNLOCK: (userId: string) => `${API_BASE_ROUTES.AUTH}/auth/${userId}/unlock`,
    RESET_PASSWORD: (userId: string) => `${API_BASE_ROUTES.AUTH}/auth/${userId}/password`,
  },

  USERS: {
    LIST: `${API_BASE_ROUTES.AUTH}/user`,
    CREATE: `${API_BASE_ROUTES.AUTH}/user/create`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.AUTH}/user/${id}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.AUTH}/user/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.AUTH}/user/${id}`,
    DELETE_MULTIPLE: `${API_BASE_ROUTES.AUTH}/user/delete-multiple`,
    UPLOAD_DOCUMENTS: (adminUserId: string) => `${API_BASE_ROUTES.AUTH}/user/upload-admin-user-documents/${adminUserId}`,
    PROFILE: (userId: string) => `${API_BASE_ROUTES.AUTH}/user/profile/${userId}`,
    USERS_LIST: `${API_BASE_ROUTES.AUTH}/user/list`,
    DELETE_PROFILE: (id: string) => `${API_BASE_ROUTES.AUTH}/user/profile/user/delete/${id}`,
    STATUS: (id: string) => `${API_BASE_ROUTES.AUTH}/user/${id}/status`,
    PROFILE_ME:   `${API_BASE_ROUTES.AUTH}/user/profile/me`,
    MANAGER_OPTIONS: `${API_BASE_ROUTES.AUTH}/user/manager-options`,
    NAMES: `${API_BASE_ROUTES.AUTH}/user/names`
  },

  // MENUS: {
  //   LIST: `${API_BASE_ROUTES.AUTH}/menu`,
  //   CREATE: `${API_BASE_ROUTES.AUTH}/menu/create`,
  //   UPDATE: (id: string) => `${API_BASE_ROUTES.AUTH}/menu/${id}`,
  //   DETAILS: (id: string) => `${API_BASE_ROUTES.AUTH}/menu/${id}`,
  //   DELETE: (id: string) => `${API_BASE_ROUTES.AUTH}/menu/${id}`,
  //   MENU_PERMISSIONS: (menuId: string) => `${API_BASE_ROUTES.AUTH}/menu/${menuId}/permissions`,
  //   ACCESSIBLE_MENUS: `${API_BASE_ROUTES.AUTH}/menu/accessible`,
  //   USER_MENUS: (userId: string) => `${API_BASE_ROUTES.AUTH}/menu/user/${userId}`,
  //   ASSIGN_MENU_PERMISSIONS: (menuId: string) => `${API_BASE_ROUTES.AUTH}/menu/${menuId}/permissions`,
  //   CHECK_MENU_PERMISSION: (menuId: string, permissionKey: string) => `${API_BASE_ROUTES.AUTH}/menu/${menuId}/permissions/${permissionKey}`,
  //   PARENT_MENU: `${API_BASE_ROUTES.AUTH}/menu/parent-menus`
  // },

  MENUS: {
    LIST: `${API_BASE_ROUTES.AUTH}/menu`,
    CREATE: `${API_BASE_ROUTES.AUTH}/menu/create`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.AUTH}/menu/${id}`,
    UPDATE_STATUS: (id: string) => `${API_BASE_ROUTES.AUTH}/menu/${id}/status`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.AUTH}/menu/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.AUTH}/menu/${id}`,
    PARENT_MENU: `${API_BASE_ROUTES.AUTH}/menu/parent-menus`,
    MY_MENUS:
  `${API_BASE_ROUTES.AUTH}/menu/me`,
    USER_MENUS: (userId: string) => `${API_BASE_ROUTES.AUTH}/access/user/${userId}/menus`,
    USER_PERMISSIONS: (userId: string) => `${API_BASE_ROUTES.AUTH}/access/user/${userId}/permissions`,
    USER_PERMISSION_TREE: (userId: string) => `${API_BASE_ROUTES.AUTH}/access/user/${userId}/permission-tree`,
    MENU_PERMISSION_PAGE: (menuId: string) => `${API_BASE_ROUTES.AUTH}/menu-permission/menu/${menuId}`,
  },

  ROLES: {
    LIST: `${API_BASE_ROUTES.AUTH}/roles`,
    CREATE: `${API_BASE_ROUTES.AUTH}/roles/create`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.AUTH}/roles/${id}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.AUTH}/roles/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.AUTH}/roles/${id}`,
    STATUS: (id: string) => `${API_BASE_ROUTES.AUTH}/roles/${id}/status`,
    ROLELIST: `${API_BASE_ROUTES.AUTH}/roles/list`,
    DELETE_MULTIPLE: `${API_BASE_ROUTES.AUTH}/roles`,
    PERMISSION_TEMPLATE: `${API_BASE_ROUTES.AUTH}/roles/permission-template`,
    CREATEBLE_ROLELIST: `${API_BASE_ROUTES.AUTH}/roles/creatable-list`,
    HIERARCHY_INFO: `${API_BASE_ROUTES.AUTH}/roles/hierarchy-info`
  },

  GROUPS: {
    LIST: `${API_BASE_ROUTES.AUTH}/groups`,
    CREATE: `${API_BASE_ROUTES.AUTH}/groups/create`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.AUTH}/groups/${id}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.AUTH}/groups/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.AUTH}/groups/${id}`,
    DELETE_MULTIPLE: `${API_BASE_ROUTES.AUTH}/groups`,
    GROUPLIST: `${API_BASE_ROUTES.AUTH}/groups/list`,
    GROUP_ROLES: (groupId: string) => `${API_BASE_ROUTES.AUTH}/groups/${groupId}/roles`,
    ASSIGN_ROLES: (groupId: string) => `${API_BASE_ROUTES.AUTH}/groups/${groupId}/roles`,
    UPDATE_ROLES: (groupId: string) => `${API_BASE_ROUTES.AUTH}/groups/${groupId}/roles`,
    REMOVE_ROLE: (groupId: string, roleId: string) => `${API_BASE_ROUTES.AUTH}/groups/${groupId}/roles/${roleId}`
  },

  GROUP_PERMISSIONS: {
    LIST: `${API_BASE_ROUTES.AUTH}/group-permissions`,
    CREATE: `${API_BASE_ROUTES.AUTH}/group-permissions`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.AUTH}/group-permissions/${id}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.AUTH}/group-permissions/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.AUTH}/group-permissions/${id}`
  },

  // MENU_PERMISSIONS: {
  //   LIST: `${API_BASE_ROUTES.AUTH}/menu-permission`,
  //   CREATE: `${API_BASE_ROUTES.AUTH}/menu-permission`,
  //   UPDATE: (id: string) => `${API_BASE_ROUTES.AUTH}/menu-permission/${id}`,
  //   DETAILS: (id: string) => `${API_BASE_ROUTES.AUTH}/menu-permission/${id}`,
  //   DELETE: (id: string) => `${API_BASE_ROUTES.AUTH}/menu-permission/${id}`
  // },

  MENU_PERMISSIONS: {
    LIST: `${API_BASE_ROUTES.AUTH}/menu-permission/all`,
    CREATE: `${API_BASE_ROUTES.AUTH}/menu-permission/create`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.AUTH}/menu-permission/update/${id}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.AUTH}/menu-permission/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.AUTH}/menu-permission/${id}`,
    MENUS_WITH_PERMISSIONS: `${API_BASE_ROUTES.AUTH}/menu-permission/menus-with-permissions`
  },

  SESSIONS: {
    LIST: `${API_BASE_ROUTES.AUTH}/session`,
    CREATE: `${API_BASE_ROUTES.AUTH}/session`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.AUTH}/session/${id}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.AUTH}/session/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.AUTH}/session/${id}`
  },

  FEATURES: {
    LIST: `${API_BASE_ROUTES.AUTH}/features`,
    CREATE: `${API_BASE_ROUTES.AUTH}/features`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.AUTH}/features/${id}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.AUTH}/features/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.AUTH}/features/${id}`
  },

  FEATURE_SETTINGS: {
    LIST: `${API_BASE_ROUTES.AUTH}/featuresetting`,
    CREATE: `${API_BASE_ROUTES.AUTH}/featuresetting`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.AUTH}/featuresetting/${id}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.AUTH}/featuresetting/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.AUTH}/featuresetting/${id}`
  },

  CONFIGURATIONS: {
    LIST: `${API_BASE_ROUTES.AUTH}/configurations`,
    CREATE: `${API_BASE_ROUTES.AUTH}/configurations`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.AUTH}/configurations/${id}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.AUTH}/configurations/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.AUTH}/configurations/${id}`
  },

  CONFIGURATION_SETTINGS: {
    LIST: `${API_BASE_ROUTES.AUTH}/configuration-settings`,
    CREATE: `${API_BASE_ROUTES.AUTH}/configuration-settings`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.AUTH}/configuration-settings/${id}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.AUTH}/configuration-settings/${id}`,
    TREE: `${API_BASE_ROUTES.AUTH}/configuration-settings/tree`,
    LOOKUPS: `${API_BASE_ROUTES.AUTH}/configuration-settings/lookups`,
    VALUES: `${API_BASE_ROUTES.AUTH}/configuration-settings/values`,
    STATUS: (id: string) => `${API_BASE_ROUTES.AUTH}/configuration-settings/${id}/status`,
    DELETE: (id: string) => `${API_BASE_ROUTES.AUTH}/configuration-settings/${id}`
  },


  APP_CONFIGS: {
    LIST: `${API_BASE_ROUTES.AUTH}/app-configs`,
    CREATE: `${API_BASE_ROUTES.AUTH}/app-configs`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.AUTH}/app-configs/${id}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.AUTH}/app-configs/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.AUTH}/app-configs/${id}`
  },

  CANDIDATES: {
    LIST: `${API_BASE_ROUTES.CANDIDATES}`,
    CREATE: `${API_BASE_ROUTES.CANDIDATES}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.CANDIDATES}/${id}`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.CANDIDATES}/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.CANDIDATES}/${id}`,
    UPDATE_PIPELINE_STAGE: (id: string) => `${API_BASE_ROUTES.CANDIDATES}/${id}/pipeline-stage`,
    UPDATE_INTERVIEW_MAPPING_STAGE: (id: string) =>
      `${API_BASE_ROUTES.CANDIDATES}/${id}/interview-mapping-stage`,
    MAPPED_JOBS: (id: string) => `${API_BASE_ROUTES.CANDIDATES}/${id}/jobs`,
    INTERVIEW_SCHEDULES: (id: string) => `${API_BASE_ROUTES.CANDIDATES}/${id}/interview-schedules`,
    CREATE_INTERVIEW_SCHEDULE: (id: string) => `${API_BASE_ROUTES.CANDIDATES}/${id}/interview-schedules`,
    START_INTERVIEW_CALL: (id: string) => `${API_BASE_ROUTES.CANDIDATES}/${id}/start-interview-call`,
    UPLOAD_DOCUMENT: (id: string) => `${API_BASE_ROUTES.CANDIDATES}/${id}/documents/upload`,
    PRESIGN_DOCUMENT_UPLOAD: (id: string) => `${API_BASE_ROUTES.CANDIDATES}/${id}/documents/presign-upload`,
    CONFIRM_DOCUMENT_UPLOAD: (id: string) => `${API_BASE_ROUTES.CANDIDATES}/${id}/documents/confirm`,
    PRESIGN_DOCUMENT_DOWNLOAD: (id: string) => `${API_BASE_ROUTES.CANDIDATES}/${id}/documents/presign-download`,
    UPLOAD_PROFILE_DOCUMENT: `${API_BASE_ROUTES.CANDIDATES}/candidates/profile/document`,
    UPLOAD_MAIL_TEMPLATE_IMAGE: `${API_BASE_ROUTES.CANDIDATES}/storage/mail-template-images`,
    PRESIGN_MAIL_TEMPLATE_IMAGE: `${API_BASE_ROUTES.CANDIDATES}/storage/mail-template-images/presign-download`,
    LIVE_INTERVIEW_ONLINE: `${API_BASE_ROUTES.CANDIDATES}/online/live-interview`,
    TECHNICAL_INTERVIEW_QUESTIONS: (interviewId: string) =>
      `${API_BASE_ROUTES.CANDIDATES}/candidates/technical-interviews/${encodeURIComponent(interviewId)}/questions`,
    TECHNICAL_INTERVIEW_QUESTIONS_AFTER_CURRENT: (interviewId: string) =>
      `${API_BASE_ROUTES.CANDIDATES}/candidates/technical-interviews/${encodeURIComponent(interviewId)}/questions/after-current`,
    TECHNICAL_INTERVIEW_QUESTIONS_LAST: (interviewId: string) =>
      `${API_BASE_ROUTES.CANDIDATES}/candidates/technical-interviews/${encodeURIComponent(interviewId)}/questions/last`,
    PRE_SCREENING_QUESTIONS: (candidateId: string) =>
      `${API_BASE_ROUTES.CANDIDATES}/candidates/${candidateId}/pre-screening-questions`,
    INTERVIEW_QUESTIONS: (candidateId: string) =>
      `${API_BASE_ROUTES.CANDIDATES}/candidates/${candidateId}/interview-questions`,
  },

  JOBS: {
    LIST: `${API_BASE_ROUTES.JOBS}`,
    CREATE: `${API_BASE_ROUTES.JOBS}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.JOBS}/${id}`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.JOBS}/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.JOBS}/${id}`,
    TITLES: `${API_BASE_ROUTES.JOBS}/titles`,
    PRE_SCREENING_QUESTIONS: (jobId: string) => `${API_BASE_ROUTES.JOBS}/${jobId}/pre-screening-questions`,
    INTERVIEW_QUESTIONS: (jobId: string) => `${API_BASE_ROUTES.JOBS}/${jobId}/interview-questions`
  },


  JOB_ASSIGNMENTS: {
    BASE: `${API_BASE_ROUTES.JOBS}/job-assignments`,
    ASSIGNABLE_USERS: `${API_BASE_ROUTES.JOBS}/job-assignments/assignable-users`,
    MY_CAPABILITIES: `${API_BASE_ROUTES.JOBS}/job-assignments/my-capabilities`,
    ACCESS_FILTER: `${API_BASE_ROUTES.JOBS}/job-assignments/access/filter`,
    OVERVIEW: (jobId: string) =>
      `${API_BASE_ROUTES.JOBS}/job-assignments/jobs/${encodeURIComponent(jobId)}`,
    MANAGERS: (jobId: string) =>
      `${API_BASE_ROUTES.JOBS}/job-assignments/jobs/${encodeURIComponent(jobId)}/managers`,
    RECRUITERS: (jobId: string) =>
      `${API_BASE_ROUTES.JOBS}/job-assignments/jobs/${encodeURIComponent(jobId)}/recruiters`,
    RELEASE_ASSIGNMENT: (jobId: string, assignmentId: string) =>
      `${API_BASE_ROUTES.JOBS}/job-assignments/jobs/${encodeURIComponent(jobId)}/assignments/${encodeURIComponent(assignmentId)}/release`,
    RELEASE_BRANCH: (jobId: string, branchId: string) =>
      `${API_BASE_ROUTES.JOBS}/job-assignments/jobs/${encodeURIComponent(jobId)}/branches/${encodeURIComponent(branchId)}/release`,
  },

  CHAT: {
    LIST: `${API_BASE_ROUTES.CHAT}`,
    CREATE: `${API_BASE_ROUTES.CHAT}`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.CHAT}/${id}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.CHAT}/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.CHAT}/${id}`
  },

  NOTIFICATIONS: {
    LIST: `${API_BASE_ROUTES.NOTIFICATIONS}`,
    CREATE: `${API_BASE_ROUTES.NOTIFICATIONS}`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.NOTIFICATIONS}/${id}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.NOTIFICATIONS}/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.NOTIFICATIONS}/${id}`
  },

  INGESTION: {
    LIST: `${API_BASE_ROUTES.INGESTION}`,
    CREATE: `${API_BASE_ROUTES.INGESTION}`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.INGESTION}/${id}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.INGESTION}/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.INGESTION}/${id}`
  },

  SCHEDULE: {
    LIST: `${API_BASE_ROUTES.SCHEDULE}`,
    CREATE: `${API_BASE_ROUTES.SCHEDULE}`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.SCHEDULE}/${id}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.SCHEDULE}/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.SCHEDULE}/${id}`,
    CALL_FORWARD: `${API_BASE_ROUTES.SCHEDULE}/sched/call/forward`,
    LIVE_CALL_SESSION: (candidateId: string) =>
      `${API_BASE_ROUTES.SCHEDULE}/sched/candidates/${encodeURIComponent(candidateId)}/live-call-session`,
  },

  REPORTS: {
    LIST: `${API_BASE_ROUTES.REPORTS}`,
    CREATE: `${API_BASE_ROUTES.REPORTS}`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.REPORTS}/${id}`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.REPORTS}/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.REPORTS}/${id}`
  },

  MAIL_TEMPLATES: {
    LIST: `${API_BASE_ROUTES.AUTH}/mail-templates`,
    CREATE: `${API_BASE_ROUTES.AUTH}/mail-templates`,
    DETAILS: (id: string) => `${API_BASE_ROUTES.AUTH}/mail-templates/${id}`,
    UPDATE: (id: string) => `${API_BASE_ROUTES.AUTH}/mail-templates/${id}`,
    DELETE: (id: string) => `${API_BASE_ROUTES.AUTH}/mail-templates/${id}`,
    BIND: (code: string, language: string) => `${API_BASE_ROUTES.AUTH}/mail-templates/bind/${encodeURIComponent(code)}/${encodeURIComponent(language)}`
  }

} as const;
